module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/keyboard-arrow-up-b50a1f1aa241a972ec4d15eba29f235f.svg";